import { render, staticRenderFns } from "./base-radio-group.vue?vue&type=template&id=ef9309ca"
import script from "./base-radio-group.ts?vue&type=script&lang=ts&external"
export * from "./base-radio-group.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef9309ca')) {
      api.createRecord('ef9309ca', component.options)
    } else {
      api.reload('ef9309ca', component.options)
    }
    module.hot.accept("./base-radio-group.vue?vue&type=template&id=ef9309ca", function () {
      api.rerender('ef9309ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/RadioGroup/base-radio-group.vue"
export default component.exports